import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 孟菲斯风格卡片组件
 * 一个具有特殊双层布局和孟菲斯风格背景的复合卡片组件。
 *
 * @example
 * ```tsx
 * <MemphisCard
 *   pattern="purple-diagonal"
 *   highlightContent={<h1 className="text-4xl font-bold">Project 1</h1>}
 *   highlightColor="sunset-orange"
 *   hoverable
 * >
 *   <h2 className="text-2xl font-bold">项目标题一</h2>
 *   <p className="text-gray-600">这是一个关于孟菲斯风格插画的设计项目...</p>
 * </MemphisCard>
 * ```
 */
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
// --- Helper Functions ---
const getPatternClasses = (pattern) => {
    const patternClassMap = {
        'purple-diagonal': 'bg-static-grape-purple bg-memphis-purple-diagonal',
        'pink-dots': 'bg-static-bubblegum-pink bg-memphis-pink-dots bg-memphis-dots-size',
        'mint-diagonal': 'bg-static-mint-green bg-memphis-mint-diagonal',
        transparent: 'bg-transparent',
    };
    return patternClassMap[pattern];
};
const getHighlightColorClass = (color) => {
    const colorClassMap = {
        'electric-yellow': 'bg-interactive-electric-yellow',
        'royal-blue': 'bg-interactive-royal-blue',
        'coral-red': 'bg-interactive-coral-red',
        'deep-purple': 'bg-interactive-deep-purple',
        'sunset-orange': 'bg-interactive-sunset-orange',
        'emerald-green': 'bg-interactive-emerald-green',
        'emerald-flash': 'bg-interactive-emerald-flash',
        'project-yellow': 'bg-interactive-project-yellow',
        'project-green': 'bg-interactive-project-green',
        'project-orange': 'bg-interactive-project-orange',
        'static-cream-yellow': 'bg-static-cream-yellow',
        'interactive-emerald-flash': 'bg-interactive-emerald-flash',
        'static-beach-orange': 'bg-static-beach-orange',
    };
    return colorClassMap[color];
};
// --- Component Definition ---
export const MemphisCard = forwardRef(({ pattern, highlightContent, highlightColor, children, hoverable = false, className, ...props }, ref) => {
    const rootClasses = cn('rounded-2xl overflow-hidden p-6 flex flex-col', // 始终保留内边距
    pattern !== 'transparent' && 'shadow-lg', // 仅在非透明时应用阴影
    getPatternClasses(pattern), hoverable && 'transition-transform duration-300 ease-in-out hover:scale-105', className);
    const highlightContainerClasses = cn('rounded-xl border-4 border-white p-6 flex items-center justify-center', 'text-white', getHighlightColorClass(highlightColor));
    const contentContainerClasses = cn('bg-white rounded-xl mt-2 p-6 flex flex-col flex-grow');
    return (_jsxs("div", { ref: ref, className: rootClasses, ...props, children: [_jsx("div", { className: highlightContainerClasses, children: highlightContent }), _jsx("div", { className: contentContainerClasses, children: children })] }));
});
MemphisCard.displayName = 'MemphisCard';
export default MemphisCard;
//# sourceMappingURL=MemphisCard.js.map